module.exports = __webpack_public_path__ + "static/media/darkbrown.8718143a.png";